import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "lookFilled"
const LookFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M6 3C7.646 3 8.97 4.213 9.84 5.807 10.725 7.43 11.25 9.621 11.25 12S10.725 16.57 9.84 18.193C8.97 19.787 7.646 21 6 21S3.03 19.787 2.16 18.193C1.275 16.57.75 14.379.75 12S1.275 7.43 2.16 5.807C3.03 4.213 4.354 3 6 3M6 4.5C5.16 4.5 4.236 5.134 3.477 6.525 2.733 7.888 2.25 9.823 2.25 12S2.733 16.112 3.477 17.475C4.236 18.865 5.16 19.5 6 19.5S7.764 18.866 8.523 17.475Q8.802 16.963 9.027 16.353C8.787 16.446 8.527 16.5 8.25 16.5 7.262 16.5 6.495 15.836 6.016 15.037 5.528 14.224 5.25 13.148 5.25 12S5.528 9.776 6.016 8.963C6.496 8.163 7.262 7.5 8.25 7.5 8.527 7.5 8.786 7.554 9.027 7.646Q8.802 7.036 8.523 6.526C7.764 5.133 6.84 4.5 6 4.5M18 3C19.646 3 20.97 4.213 21.84 5.807 22.725 7.43 23.25 9.621 23.25 12S22.725 16.57 21.84 18.193C20.97 19.787 19.646 21 18 21S15.03 19.787 14.16 18.193C13.275 16.57 12.75 14.379 12.75 12S13.275 7.43 14.16 5.807C15.03 4.213 16.354 3 18 3M18 4.5C17.16 4.5 16.236 5.134 15.477 6.525 14.733 7.888 14.25 9.823 14.25 12S14.733 16.112 15.477 17.475C16.236 18.865 17.16 19.5 18 19.5S19.764 18.866 20.523 17.475Q20.803 16.963 21.027 16.353C20.787 16.446 20.527 16.5 20.25 16.5 19.262 16.5 18.495 15.836 18.016 15.037 17.528 14.224 17.25 13.148 17.25 12S17.528 9.776 18.016 8.963C18.496 8.163 19.262 7.5 20.25 7.5 20.527 7.5 20.786 7.554 21.027 7.646Q20.802 7.036 20.523 6.526C19.764 5.133 18.84 4.5 18 4.5"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default LookFilledIcon
